module.exports = __webpack_public_path__ + "media/ding.caae5176.mp3";